import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { serialize } from 'object-to-formdata';
import { IAmendmentPagedRequest } from '../../../../model/sge/amendment/request/amendment-paged-request';
import { IAmendmentAddEditRequest } from '../../../../model/sge/amendment/request/amendment-add-edit-request';
import { IAmendmentPagedResponse } from '../../../../model/sge/amendment/response/amendment-paged-response';
import { IAmendmentResponse } from '../../../../model/sge/amendment/response/amendment-response';

const defaultPath = 'Amendment';

const list = async (params: IAmendmentPagedRequest): Promise<Pagination<IAmendmentPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => Object.assign(new Pagination<IAmendmentPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<IAmendmentResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IAmendmentAddEditRequest): Promise<IAmendmentResponse> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: true, dotsForObjectNotation: false });
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => response.data);
};

const edit = async (id: number, params: IAmendmentAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    });
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const AmendmentAppService = { list, getById, add, edit, remove };
export default AmendmentAppService;
